import { Theme } from '@mui/material';

export const getLocationsWrapStyles = ({ isSmallScreen }: { isSmallScreen: boolean }) => ({
	position: 'relative',
	height: 'auto',
	...(!isSmallScreen && {
		height: 'calc(100vh - 12.5rem)',
		'&::before': {
			content: "''",
			display: 'block',
			position: 'absolute',
			bottom: 0,
			width: '100%',
			height: '2rem',
			background: 'linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 1))',
			zIndex: 1,
		},
	}),
});

export const getLocationsCardContainerStyles = ({ theme }: { theme: Theme }) => ({
	position: 'relative',
	display: 'flex',
	flexDirection: 'column',
	flexWrap: 'nowrap',
	px: '',
	paddingTop: { xs: '0', md: '1rem' },
	backgroundColor: theme.palette.backgrounds?.white,
	height: 'calc(100% - 5rem)',
});

export const locationsListStyles = {
	display: 'flex',
	flexDirection: 'column',
	flexWrap: 'nowrap',
	overflow: 'scroll',
	'::-webkit-scrollbar': {
		display: 'none',
	},
	msOverflowStyle: 'none',
	scrollBarWidth: 'none',
};

export const getListTogglerStyles = ({ theme }: { theme: Theme }) => ({
	padding: '0.5rem 1rem',
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	borderBottom: '0.0625rem solid',
	borderColor: 'neutrals.primary',
	position: 'absolute',
	top: '-3rem',
	visibility: 'visible',
	width: '100%',
	pointerEvents: 'painted',
	backgroundColor: theme.palette.backgrounds?.white,
});

export const mapPinTextStyles = (theme: Theme) => {
	return {
		...theme.typography.button,
		fontSize: '.6rem',
		fontStyle: 'normal',
		lineHeight: 'normal',
	};
};

export const pullerBoxStyles = {
	width: '3.25rem',
	height: '0.25rem',
	backgroundColor: 'grey',
	borderRadius: '0.25rem',
	position: 'absolute',
	top: '0.5rem',
	left: '50%',
	transform: 'translateX(-50%)',
};

export const drawerStyles = {
	visibility: 'visible',
	display: 'flex',
	flexDirection: 'column',
	maxHeight: 'calc(100% - 14rem)',
	minHeight: '40%',
};
